export default __webpack_public_path__ + "static/media/bg-konto.ccbac42b.svg";